<template>
  <div class="link-wrap grid-x align-middle">
    <button class="menu-link-sm" aria-haspopup="dialog" @click.prevent="openInternationalSlideout">
      {{ firstLinkText }}
    </button>

    <CommonFlagCommon width="12px" height="12px" class="rounded margin-left-xxs" />

    <button v-if="!isDomestic" class="margin-left-xxs menu-link-sm" @click="handleGoToUSSite">Go to U.S. site</button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Cookie } from '@nuxt-common/util/app/utils/cookie';

import useInternationalSlideout from '~/composables/features/useInternationalSlideout';

const pageData = usePageData();

const isDomestic = computed(() => pageData.navigation.context.isDomestic);
const currencyCode = computed(() => pageData.navigation.context.currencyCode);
const firstLinkText = computed(() => (isDomestic.value ? currencyCode.value : 'Shipping To'));

const { openInternationalSlideout } = useInternationalSlideout();

function handleGoToUSSite() {
  Cookie.set('shippingCountry', 'US');
  Cookie.set('currency', 'USD');
  window.location.assign('/');
}
</script>

<style scoped lang="scss" brand="mcom">
.menu-link-sm {
  color: $white;
}
</style>
